// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".NavSidebarItemGroup-base__IBPAG{display:flex;flex-direction:column}.NavSidebarItemGroup-items__v50z7{display:flex;flex-direction:column;overflow:hidden;transition:var(--duration-normal);transition-property:max-height}.NavSidebarItemGroup-items__v50z7 *{pointer-events:none}.NavSidebarItemGroup-open__vONoi{gap:var(--size-0_5)}.NavSidebarItemGroup-open__vONoi .NavSidebarItemGroup-items__v50z7{gap:var(--size-0_5)}.NavSidebarItemGroup-open__vONoi .NavSidebarItemGroup-items__v50z7 *{pointer-events:all}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"base": "NavSidebarItemGroup-base__IBPAG",
	"items": "NavSidebarItemGroup-items__v50z7",
	"open": "NavSidebarItemGroup-open__vONoi"
};
export default ___CSS_LOADER_EXPORT___;
